/* eslint-disable no-unused-vars */
import React from 'react'
import PropTypes from 'prop-types'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_FindAnIndependantFinancialAdviser.scss'
import * as commonStyles from '../../common/_common.scss'
import history from '../../core/history'
import { servers } from '../../config'
import SubmitButton from '../../common/forms/SubmitButton'
import { Form, Button, Row, Col } from 'react-bootstrap'
import LocationContainer from './Location/LocationContainer'
import PreferredLanguagesContainer from './PreferredLanguagesContainer'
import InvestorDescriptionContainer from './InvestorDescriptionContainer'
import FinancialServicesContainer from './FinancialServicesContainer'
import InvestmentAmountContainer from './InvestmentAmountContainer'
import Heading from './Heading'
import { clearisInvalid } from './findAnIndependantFinancialAdviserActions'
import {
  investorDescriptionSelected
  , clearAllSearchCriteria
  , setUserAddress
  , events,
  fetchTotalMatchingProfiles
} from './searchCriteriaActions'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { validateState } from './FinancialServicesContainer/financialServicesContainerActions'
import classNames from 'classnames'
import 'bootstrap/dist/css/bootstrap.min.css';

class FindAnIndependantFinancialAdviser extends React.Component {
  static propTypes = {
    pageSize: PropTypes.number.isRequired,
    findAnIfa: PropTypes.object.isRequired,
    investorDescriptionSelected: PropTypes.func.isRequired,
    clearAllSearchCriteria: PropTypes.func.isRequired,
    clearisInvalid: PropTypes.func.isRequired,
    setUserAddress: PropTypes.func.isRequired,
    searchCriteriaChanged: PropTypes.bool.isRequired,
    fetchingProfileMatches: PropTypes.bool.isRequired,
    fetchTotalMatchingProfiles: PropTypes.func.isRequired,
    searchCriteria: PropTypes.object.isRequired,
    totalMatchingProfiles: PropTypes.number,
    validate: PropTypes.func.isRequired
  }

  constructor (props) {
    super(props)

    this.state = {
      showValidationErrors: false,
      criteriaDidChange: false
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.setUserLocation = this.setUserLocation.bind(this)
  }

  isInvalidChanged (props, nextProps) {
    const { financialServicesContainer, investorDescriptionContainer, investmentAmountContainer } = props.findAnIfa.isInvalid
    return financialServicesContainer.message !== nextProps.findAnIfa.isInvalid.financialServicesContainer.message ||
      investorDescriptionContainer.message !== nextProps.findAnIfa.isInvalid.investorDescriptionContainer.message ||
      investmentAmountContainer.message !== nextProps.findAnIfa.isInvalid.investmentAmountContainer.message
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.searchCriteriaChanged && this.props.searchCriteriaChanged) {
      this.props.fetchTotalMatchingProfiles(this.props.searchCriteria);
    }
  }

  buildSearchUrl (searchCriteria) {
    var financialServices = ''
    var languagePreferences = ''
    var location = searchCriteria.userAddress || ''

    if (location.includes(' ')) {
    location = location.replace(' ', ',')
    }

    searchCriteria.financialServices.forEach((serviceId, index, arr) => {
      financialServices = financialServices + serviceId + (index < arr.length - 1 ? ',' : '')
    })

    searchCriteria.selectedPreferredLanguageIds.forEach((languageId, index, arr) => {
      languagePreferences = languagePreferences + languageId + (index < arr.length - 1 ? ',' : '')
    })

    var url = '/search-results/' + `investorDescriptionId=${searchCriteria.investorDescriptionId}&` +
      `location=${encodeURIComponent(location)}&` +
      `lumpSum=${searchCriteria.investmentAmounts.onceOffAmount || ''}&` +
      `debitOrder=${searchCriteria.investmentAmounts.monthlyAmount || ''}&` +
      `financialServices=${financialServices}&` +
      `languagePreferences=${languagePreferences}`

    return url
  }

     async submitSearch (searchCriteria) {
    if (searchCriteria.userAddress && searchCriteria.userAddress.includes(' ')) {
      searchCriteria.userAddress = searchCriteria.userAddress.replace(' ', ',')
    }

    const response = await fetch(`${servers.apiBase.replace(/\/+$/, '')}/search/`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(searchCriteria)
    })
    return response.json()
  }

  handleSubmit () {
  this.props.validate()
  const { isInvalid, mandatorySearchCriteriaCompleted } = this.props.findAnIfa

  if (isInvalid.formIsValid && mandatorySearchCriteriaCompleted) {
    const searchCriteria = { ...this.props.findAnIfa.searchCriteria }

    if (searchCriteria.userAddress && searchCriteria.userAddress.includes(' ')) {
      searchCriteria.userAddress = searchCriteria.userAddress.replace(' ', ',')
    }

    this.submitSearch(searchCriteria)
      .then(data => {

        const criteriaString =
          `investorDescriptionId=${searchCriteria.investorDescriptionId}` +
          `&location=${encodeURIComponent(searchCriteria.userAddress)}` +
          `&lumpSum=${searchCriteria.investmentAmounts.onceOffAmount || ''}` +
          `&debitOrder=${searchCriteria.investmentAmounts.monthlyAmount || ''}` +
          `&financialServices=${searchCriteria.financialServices.join(',')}` +
          `&languagePreferences=${searchCriteria.selectedPreferredLanguageIds.join(',')}`

        history.push(`/search-results/criteria/${criteriaString}`, { results: data })
      })
      .catch(err => console.error('Search failed:', err))
  } else {
    this.scrollToError()
  }

  this.setState({ showValidationErrors: true })
}

  scrollToError () {
    const sidebarContentContainer = document.getElementsByClassName('sidebar-content-container')[0]
    const { findAnIfa } = this.props

    const investorContainerHeight = getHeight(document.getElementById('investorDescriptionContainer'))
    const financialServicesContainerHeight = getHeight(document.getElementById('financialServicesContainer'))
    const investmentAmountContainerHeight = 300 + getHeight(document.getElementById('investmentAmountContainer'))
    const locationContainerHeight = getHeight(document.getElementById('locationContainer')) - 150

    if (!findAnIfa.isInvalid.investorDescriptionContainer.valid) {
      sidebarContentContainer.scrollTop = investorContainerHeight
      return
    }
    if (!findAnIfa.isInvalid.financialServicesContainer.valid) {
      sidebarContentContainer.scrollTop = investorContainerHeight + financialServicesContainerHeight
      return
    }
    if (!findAnIfa.isInvalid.investmentAmountContainer.valid) {
      sidebarContentContainer.scrollTop = investorContainerHeight + financialServicesContainerHeight + investmentAmountContainerHeight
      return
    }
    if (!findAnIfa.isInvalid.userLocationContainer.valid) {
      sidebarContentContainer.scrollTop = investorContainerHeight + financialServicesContainerHeight + investmentAmountContainerHeight + locationContainerHeight
      return
    }
  }

  scrollToTop () {
    const sidebarContentContainer = document.getElementsByClassName('sidebar-content-container')[0]
    sidebarContentContainer.scrollTop = 0
  }

  setUserLocation (location) {
    this.props.setUserAddress(location)
  }

  render () {
    let centre = classNames(
      styles['margin-left-auto'],
      styles['margin-right-auto'],
      styles['display-block']
    )
    const { pageSize } = this.props
    const { isInvalid, message, valid } = this.props.findAnIfa.isInvalid.investorDescriptionContainer
    return (
      <Row className="justify-content-center">
        <Col xs={12} sm={12} md={12} lg={12}>
          <form className={styles['ifaForm']}>
            <Heading pageSize={pageSize} />
            <InvestorDescriptionContainer
              showValidationErrors={this.state.showValidationErrors}
              isInvalid={!valid}
              message={message}
              valid={valid}
            />
            <FinancialServicesContainer
              showValidationErrors={this.state.showValidationErrors}
              validation={this.props.findAnIfa.isInvalid.financialServicesContainer} />
            <InvestmentAmountContainer
              showValidationErrors={this.state.showValidationErrors}
              validation={this.props.findAnIfa.isInvalid.investmentAmountContainer} />
            <LocationContainer
              showValidationErrors={this.state.showValidationErrors}
              validation={this.props.findAnIfa.isInvalid.userLocationContainer} />
            <PreferredLanguagesContainer
              showValidationErrors={this.state.showValidationErrors}
              validation={this.props.findAnIfa.isInvalid.preferredLanguagesContainer} />
            <Row className={commonStyles['bg-white']}>
              <Col xs={12} sm={12} md={12} lg={12}>
                <section className={styles['padding-search-button-container']} >
                  <Form.Group>
                    <SubmitButton
                      isValid
                      size={'large'}
                      preventDefault
                      className={classNames(centre, commonStyles['x-large-button'])}
                      buttonText={'Find an adviser'}
                      onClick={this.handleSubmit} />
                  </Form.Group>
                  <Form.Group className={styles['margin-search-button-form-group']}>
                    <Button className={classNames(centre, styles['location-button-mobile'])}
                      size='large'
                      variant='link'
                      style={{ textDecoration: 'none', textAlign: 'center' }}
                      onClick={() => {
                        this.scrollToTop()
                        this.props.clearAllSearchCriteria()
                        this.props.clearisInvalid()
                      }}>
                      Clear and try again?
                  </Button>
                  </Form.Group>
                </section>
              </Col>
            </Row>
          </form>
        </Col>
      </Row>
    )
  }
}

const mapStateToProps = ({ findAnIfa, searchResults }) => {
  const { searchCriteria } = findAnIfa
  return {
    pageSize: searchResults.pageSize,
    findAnIfa: findAnIfa,
    searchCriteria: searchCriteria,
    fetchingProfileMatches: searchCriteria.fetchingProfileMatches,
    totalMatchingProfiles: searchCriteria.matchingProfiles,
    searchCriteriaChanged: searchCriteria.searchCriteriaChanged
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    validate: validateState,
    fetchTotalMatchingProfiles,
    investorDescriptionSelected: investorDescriptionSelected,
    clearAllSearchCriteria: clearAllSearchCriteria,
    clearisInvalid: clearisInvalid,
    setUserAddress: setUserAddress
  }, dispatch)
}

function getHeight (element) {
  element = element.cloneNode(true)
  element.style.visibility = 'hidden'
  document.body.appendChild(element)
  var height = element.offsetHeight + 0
  document.body.removeChild(element)
  element.style.visibility = 'visible'
  return height
}

export default connect(mapStateToProps, mapDispatchToProps)(FindAnIndependantFinancialAdviser)
